/* eslint-disable import/no-anonymous-default-export */
import { TaskList } from './list/TaskList';

export default {
    list: TaskList,
};
